import '../assets/MazDialog.css';
import { defineComponent as T, ref as N, onMounted as S, watch as O, openBlock as d, createBlock as y, Teleport as F, createVNode as L, Transition as P, withCtx as k, createElementBlock as C, normalizeClass as g, createElementVNode as p, withModifiers as H, mergeProps as h, renderSlot as m, createCommentVNode as n, defineAsyncComponent as V, useAttrs as K, computed as w, createTextVNode as W, toDisplayString as I, unref as z } from "vue";
const M = "--backdrop-present", q = /* @__PURE__ */ T({
  inheritAttrs: !1,
  __name: "MazBackdrop",
  props: {
    modelValue: { type: Boolean, default: !1 },
    teleportSelector: { default: "body" },
    beforeClose: { type: Function, default: void 0 },
    persistent: { type: Boolean, default: !1 },
    noCloseOnEscKey: { type: Boolean, default: !1 },
    transitionName: { default: "backdrop-anim" },
    backdropClass: { default: void 0 },
    backdropContentClass: { default: void 0 }
  },
  emits: ["open", "close", "update:model-value", "before-close"],
  setup(r, { expose: c, emit: a }) {
    const l = () => {
      document.documentElement.classList.add(M);
    }, u = async () => {
      document.querySelector(".m-backdrop.--present") || document.documentElement.classList.remove(M);
    }, i = a, e = r, s = N(e.modelValue);
    function t() {
      B(!1);
    }
    async function B(o) {
      var b;
      o || (i("before-close"), await ((b = e.beforeClose) == null ? void 0 : b.call(e))), s.value = o;
    }
    function E() {
      i("open");
    }
    function A() {
      i("update:model-value", !1), i("close"), v();
    }
    function $() {
      e.persistent || t();
    }
    function f(o) {
      !e.noCloseOnEscKey && o.key === "Escape" && !e.persistent && t();
    }
    function D() {
      l(), document.addEventListener("keyup", f, !1);
    }
    function v() {
      document.removeEventListener("keyup", f), u();
    }
    return S(() => {
      e.modelValue ? D() : v();
    }), O(
      () => e.modelValue,
      (o) => {
        s.value = o, o ? D() : v();
      }
    ), c({
      onBackdropAnimationEnter: E,
      onBackdropAnimationLeave: A,
      onBackdropClicked: $,
      close: t,
      present: s,
      toggleModal: B,
      onKeyPress: f
    }), (o, b) => (d(), y(F, { to: o.teleportSelector }, [
      L(P, {
        appear: "",
        name: o.transitionName,
        onAfterEnter: E,
        onAfterLeave: A
      }, {
        default: k(() => [
          s.value ? (d(), C(
            "div",
            {
              key: 0,
              class: g(["m-backdrop --present", [o.backdropClass]]),
              tabindex: "-1",
              role: "dialog"
            },
            [
              p(
                "button",
                {
                  class: g(["m-backdrop-overlay", { "--disabled": o.persistent }]),
                  tabindex: "-1",
                  onClick: H($, ["self"])
                },
                null,
                2
                /* CLASS */
              ),
              p(
                "div",
                h({
                  class: ["m-backdrop-content", o.backdropContentClass]
                }, o.$attrs, {
                  role: "document",
                  tabindex: "0"
                }),
                [
                  m(o.$slots, "default", { close: t })
                ],
                16
                /* FULL_PROPS */
              )
            ],
            2
            /* CLASS */
          )) : n("v-if", !0)
        ]),
        _: 3
        /* FORWARDED */
      }, 8, ["name"])
    ], 8, ["to"]));
  }
}), U = {
  key: 0,
  id: "dialogTitle",
  class: "maz-my-0 maz-text-xl maz-font-semibold"
}, X = {
  id: "dialogDesc",
  class: "m-dialog-content"
}, j = {
  key: 0,
  class: "m-dialog-footer"
}, G = /* @__PURE__ */ T({
  __name: "MazDialog",
  props: {
    modelValue: { type: Boolean },
    title: { default: void 0 },
    noClose: { type: Boolean, default: !1 },
    width: { default: "500px" },
    maxWidth: { default: "95vw" },
    maxHeight: { default: "95vh" },
    scrollable: { type: Boolean, default: !1 },
    persistent: { type: Boolean, default: !1 },
    teleportSelector: {},
    beforeClose: {},
    noCloseOnEscKey: { type: Boolean },
    transitionName: {},
    backdropClass: {},
    backdropContentClass: {}
  },
  emits: ["open", "close", "update:model-value"],
  setup(r) {
    const c = V(() => import("./MazBtn-CX4OgPzp.mjs")), a = V(() => import("./x-mark-BP8zWe_C.mjs")), l = K(), u = w(() => ({
      ...l,
      class: void 0,
      style: void 0
    })), i = w(() => ({
      class: l.class,
      style: l.style
    }));
    return (e, s) => (d(), y(q, h(u.value, {
      persistent: e.persistent,
      "model-value": e.modelValue,
      "transition-name": "modal-anim",
      "aria-labelledby": "dialogTitle",
      "aria-describedby": "dialogDesc",
      onClose: s[0] || (s[0] = (t) => e.$emit("close", t)),
      onOpen: s[1] || (s[1] = (t) => e.$emit("open", t)),
      "onUpdate:modelValue": s[2] || (s[2] = (t) => e.$emit("update:model-value", t))
    }), {
      default: k(({ close: t }) => [
        p(
          "div",
          h({
            class: ["m-dialog", { "--scrollable": e.scrollable }],
            role: "dialog",
            "aria-modal": "true",
            style: [{ width: e.width, maxWidth: e.maxWidth, maxHeight: e.maxHeight }]
          }, i.value),
          [
            n(`
          @slot Header slot
            @binding {Function} close close function
        `),
            m(e.$slots, "header", { close: t }, () => [
              p(
                "div",
                {
                  class: g(["m-dialog-header", { "--has-title": e.$slots.title || e.title }])
                },
                [
                  e.$slots.title || e.title ? (d(), C("h2", U, [
                    n(`
                @slot Title slot in the header
              `),
                    m(e.$slots, "title", {}, () => [
                      W(
                        I(e.title),
                        1
                        /* TEXT */
                      )
                    ], !0)
                  ])) : n("v-if", !0),
                  !e.noClose && !e.persistent ? (d(), y(z(c), {
                    key: 1,
                    class: "m-dialog-closebtn",
                    color: "transparent",
                    onClick: t
                  }, {
                    default: k(() => [
                      L(z(a), { class: "maz-text-lg" })
                    ]),
                    _: 2
                    /* DYNAMIC */
                  }, 1032, ["onClick"])) : n("v-if", !0)
                ],
                2
                /* CLASS */
              )
            ], !0),
            p("div", X, [
              n(`
            @slot Default content
              @binding {Function} close close function
          `),
              m(e.$slots, "default", { close: t }, void 0, !0)
            ]),
            e.$slots.footer ? (d(), C("div", j, [
              n(`
            @slot Footer slot
              @binding {Function} close close function
          `),
              m(e.$slots, "footer", { close: t }, void 0, !0)
            ])) : n("v-if", !0)
          ],
          16
          /* FULL_PROPS */
        )
      ]),
      _: 3
      /* FORWARDED */
    }, 16, ["persistent", "model-value"]));
  }
}), J = (r, c) => {
  const a = r.__vccOpts || r;
  for (const [l, u] of c)
    a[l] = u;
  return a;
}, R = /* @__PURE__ */ J(G, [["__scopeId", "data-v-cb9a9d45"]]);
export {
  R as M,
  J as _
};
